<script setup lang="ts">
import { useUserStore } from '#store/index';
import { C4SpinnerLoader } from '@c4-links/vue3-links-components';
import { storeToRefs } from 'pinia';
import { onMounted, watch } from 'vue';
import { useLanguage } from './components/composables/useLanguage';
import { useProductFruits } from './components/composables/useProductFruits';
import AppHeader from './components/layouts/AppLayoutComponents/AppHeader.vue';
import LayoutPage from './components/layouts/LayoutPage.vue';
import ForbiddenView from './views/ForbiddenView.vue';

const userStore = useUserStore();
const { loading, me, error } = storeToRefs(userStore);
const { t } = useLanguage();

watch(me, (user) => {
  if (user) {
    useProductFruits(user);
  }
});

onMounted(async () => {
  await userStore.getMe();
});
</script>

<template>
  <div>
    <LayoutPage v-if="me && !loading && !error" data-test-id="layout-page-app-view">
      <template #header>
        <AppHeader />
      </template>
      <RouterView />
    </LayoutPage>
    <C4SpinnerLoader
      v-else-if="!me && loading && !error"
      data-test-id="spinner-loader-app-view"
      class="flex items-center justify-center h-screen"
    />
    <ForbiddenView
      v-else
      icon="lock"
      data-test-id="forbidden-page-app-view"
      :title="t('error_page.no_access_title')"
      :subtitle="t('error_page.no_access_subtitle')"
    />
  </div>
</template>
